export enum SessionIDType {
  PRE_INIT_SESSION = 'pre_init_session',
  CHAT_BOT = 'chatbot',
  AGENT = 'agent',
}

export const FAKE_SESSION_ID = 'init-session';
export const PRE_INIT_SESSION_ID = 'pre-init-session';

export const isIosReg = /iPhone|iPad|iPod/i;
